import { FC, memo } from 'react'
import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { EventKindListToolbar } from './components/eventKindListToolbar/eventKindListToolbar'
import { EventKindListGrid } from './components/eventKindListGrid/eventKindListGrid'

export const EventKindList: FC = memo(() => {
  return (
    <div className="flex flex-col h-full w-full overflow-auto gap-y-2">
      <CrewErrorBoundary>
        <EventKindListToolbar />
      </CrewErrorBoundary>

      <CrewErrorBoundary>
        <EventKindListGrid />
      </CrewErrorBoundary>
    </div>
  )
})
